import { AssetTypes } from './enums/AssetTypes';

// tslint:disable-next-line: no-reserved-keywords
export function getAssetThumbnailUrl(asset: { id: string; type: string }): string {
    if (asset.type === AssetTypes.MeasurementXLS) {
        return '/assets/img/excel_thmb.png';
    }
    if (asset.type === AssetTypes.MeasurementPDF) {
        return '/assets/img/pdf_thmb.png';
    }
    return `/api/assets/${asset.id}/download?thumb=true`;
}
